import React, { useState, useEffect, useContext, useMemo, useRef } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Grid, Button } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Map from "./map/map";
import CommunitiesList from "./communitiesList";
import SearchBox from "./search";
import StartCommunities from "../../Modules/Activity/Community/Start Communities/StartCommunities";
import formattedCommunitiesList from "./utils";
import logo from "src/Assets/images/skopic.png";
import AddIcon from "../../Assets/images/LandingPageImages/Add-Icon.svg";
import CloseButton from "src/Assets/images/CloseButton.svg";
import useStyles from "./styles";
import API from "../../network";
import { SignupContext } from "src/context/SignupContext/SignupContext";
import Page from "src/layout/Page";
import { CircularProgress, IconButton } from "@material-ui/core";
import { CommunityContext } from "src/context/CommunityContext/CommunityContext.js";
import countryDialCodeData from "src/Constants/CountryDialCodes.json";
import { IoIosClose } from "react-icons/io";
import { Popover, Typography } from "@material-ui/core";
import styles from "src/Assets/css/LandingPage/Switch.module.css";
import Cookies from "js-cookie";
import * as SigInOutActions from "src/store/actions/SignInActions/SignInAction.js";

const indiaCenter = {
  lat: 20.5937,
  lng: 78.9629,
};
const DefaultCommunity = ({
  signIn,
  countryId,
  defaultTenantCountry,
  hideSearch,
}) => {
  const {
    searchClass,
    buttonContainer,
    searchBtn,
    searchOrStartBtn,
    DefaultBlockedCloseBtn,
  } = useStyles();
  const communityContext = useContext(CommunityContext);
  // const userDetails = useSelector((state) => state?.SignInReducer?.userDetails);

  const location = useLocation();
  const history = useHistory();
  const listRef = useRef(null);
  const dispatch = useDispatch();

  const [communitiesList, setCommunitiesList] = useState([]);
  const [allCommunities, setAllCommunities] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [searchCommunitiesList, setSearchCommunitiesList] = useState([]);
  const [isGlobalSearch, setIsGlobalSearch] = useState(false);
  const [selectedItem, setSelectedItem] = useState("");
  const [locationIconClickedCommunityId, setLocationIconClickedCommunityId] =
    useState(null);
  const [map, setMap] = useState(null);
  const [showTooltip, setShowTooltip] = useState(false);
  const [selectedMarker, setSelectedMarker] = useState("");
  const [followStatusResponse, setFollowStatusResponse] = useState({});
  const [defaultResponse, setDefaultResponse] = useState([]);
  const [openStartCommunity, setOpenStartCommunity] = useState(false);
  const [prevSelectedCountry, setPrevSelectedCountry] = useState({});
  const [currentCountry, setChangedCountry] = useState({});
  const [countryList, setCountryList] = useState([]);
  const [countryTenantList, setCountryTenantList] = useState([]);
  const [communityResp, setCommunityResp] = useState({});
  const [loading, setLoading] = useState(false);
  const [isClickedOnSearchTxt, setIsClickOnSearchTxt] = useState(false);
  const [showSearchBeforeSignIn, setShowSearchBeforeSignIn] = useState(false);
  const [showPrivateAlertPopup, setShowPrivateAlertPopup] = useState(false);
  const [showPrivateAlertPopupStatus, setShowPrivateAlertPopupStatus] =
    useState(false);
  const [showAlertBox, setShowAlertBox] = useState(true);
  const settingsData = useSelector((state) => state.voteupReducer.settingsData);
  const [isPrivatePopupClosed, setIsPrivatePopupClosed] = useState(true);
  const [markersData, setMarkersData] = useState([]);
  const [countryHasDefaultCommBlocked, setCountryHasDefaultCommBlocked] =
    useState(false);
  const [userDetails, setUserDetails] = useState(null);
  const signupContext = useContext(SignupContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const informationId = open ? "display-name-info-popover" : undefined;

  const hasCountryCommunity = countryTenantList?.hasOwnProperty(
    currentCountry?.country_name,
  )
    ? countryTenantList[currentCountry?.country_name]?.length > 0
    : false;

  const { previousCountry } = location.state || {};

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const resp = await API.fetchCountryWithCommunity();
        // const resp = await API.fetchCountryList();
        const { countryList, countryTenantList } = resp?.data || {};
        setCountryList(countryList);
        setCountryTenantList(countryTenantList || {});
        let defaultCountry = {};
        const userDataResp = await API.fetchLoginUser();
        setUserDetails(userDataResp?.data);
        const userDefaultTenantCountry =
          userDataResp?.data?.userData?.defaultTenantCountry;
        //only for after signin flow: set default country, if countryId is available
        if (signIn && userDefaultTenantCountry) {
          defaultCountry = countryList.find(
            (country) => country.country_name === userDefaultTenantCountry,
          );
        } else {
          defaultCountry = countryList.find(
            (country) => country.countryId === 1,
          );
        }

        // if found
        if (
          (previousCountry && previousCountry.countryId) ||
          (defaultCountry && defaultCountry.countryId)
        ) {
          setChangedCountry(
            previousCountry?.countryId ? previousCountry : defaultCountry,
          );
        }

        //fetch communities list
        await fetchNearByComm(userDataResp?.data);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updateAlertShow = (alertStatus) => {
    setShowPrivateAlertPopup(alertStatus);
    setShowPrivateAlertPopupStatus(alertStatus);
  };

  useEffect(() => {
    if (listRef.current) {
      listRef.current.scrollTop = 0;
    }
  }, [locationIconClickedCommunityId]);

  useEffect(() => {
    // The purpose of this useEffect is to show a warning to the user if they try
    // to refresh the page during the signup process, specifically when they haven't
    // completed the community selection. If the user refreshes the page unnecessarily,
    // the signup flow will break, and they won't be able to complete the signup process.
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue =
        "Warning: If you refresh the page, you will lose your signup progress and any entered data. Please choose a default community to complete the signup process instead of refreshing.";
    };

    if (
      signIn !== true &&
      userDetails?.userData?.communityStatus !== "communityBlocked"
    ) {
      // Add the event listener only when signIn !== true
      window.addEventListener("beforeunload", handleBeforeUnload);
    }

    // Cleanup function to remove the event listener
    return () => {
      if (
        signIn !== true &&
        userDetails?.userData?.communityStatus !== "communityBlocked"
      ) {
        window.removeEventListener("beforeunload", handleBeforeUnload);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onClickDisplayNameInfo = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const onHideDisplayNameInfo = () => {
    setAnchorEl(null);
  };

  // useEffect(() => {
  //   if (location?.state && countryList.length) {
  //     const countryCode = location?.state?.countryCode;
  //     if (countryCode) {
  //       const defaultCountry = countryList.find(country => country.country_code === countryCode);
  //       setChangedCountry(defaultCountry);
  //     }
  //   }
  // }, [location, countryList]);

  // const getNearByUserCommunities = async () => {
  //   await API.getNearByUserCommunities().then((res) => {
  //     setAllCommunities(res.data.physicalTenantList);
  //     if (res?.data && location?.pathname === "/defaultCommunity") {
  //       setCommunitiesList(
  //         formattedCommunitiesList(res?.data, location?.state?.countryId)
  //       );
  //     } else {
  //       setCommunitiesList(formattedCommunitiesList(res?.data, ""));
  //     }
  //   });
  // };

  // useEffect(() => {
  //   if (location?.pathname !== "/defaultCommunity") {
  //     getNearByUserCommunities();
  //   }
  // }, []);

  useEffect(() => {
    if (Object.keys(communityResp).length) {
      const formattedCommList = formattedCommunitiesList(
        communityResp,
        currentCountry?.countryId || "",
      );
      setCommunitiesList([...formattedCommList]);
      // if there are only private communities exist in a country
      const areEveryCommPrivate =
        formattedCommList?.length > 0
          ? formattedCommList.every(
              (ele) => String(ele?.communityType).toLowerCase() === "private",
            )
          : false;
      const areEveryCommHidden =
        formattedCommList?.length > 0
          ? formattedCommList.every(
              (ele) => String(ele?.tenantView).toLowerCase() === "hide",
            )
          : false;
      const areEveryCommNotFollowing =
        formattedCommList?.length > 0
          ? formattedCommList.every(
              (ele) => ele?.followStatus !== 1 && ele?.followStatus !== 2,
            )
          : false;
      const hasCountryComm = hasCountryCommunities(
        currentCountry?.country_name,
      );
      if (!signIn && hasCountryComm && areEveryCommPrivate) {
        updateAlertShow(true);
      } else if (
        signIn &&
        hasCountryComm &&
        areEveryCommHidden &&
        areEveryCommPrivate &&
        areEveryCommNotFollowing
      ) {
        updateAlertShow(true);
      } else if (signIn) {
        updateAlertShow(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentCountry, communityResp]);

  const hasCountryCommunities = (country_name) => {
    if (countryTenantList?.hasOwnProperty(country_name))
      return countryTenantList[country_name]?.length > 0;
    return false;
  };

  const onChangeCountry = (country) => {
    setPrevSelectedCountry({});
    const hasCountryComm = hasCountryCommunities(country?.country_name);
    // if country has no communities then open "Start Community" popup
    if (!hasCountryComm) {
      // making current country as previous country before changing to new country
      const prevCountry = { ...currentCountry };
      if (prevCountry && prevCountry?.country_name) {
        setPrevSelectedCountry({ ...prevCountry });
      }

      //open Start Community popup
      // setOpenStartCommunity(true);
      setShowPrivateAlertPopup(true);
    }
    setChangedCountry(country);
    setShowAlertBox(true);
  };

  useEffect(() => {
    if (
      (location?.pathname !== "/defaultCommunity" &&
        followStatusResponse?.status === 200) ||
      (location?.pathname !== "/defaultCommunity" &&
        defaultResponse?.status === 200)
    ) {
      fetchNearByComm(userDetails);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [followStatusResponse, defaultResponse]);

  const fetchNearByComm = async (userDetails) => {
    try {
      setLoading(true);
      let res;
      if (signIn) {
        res = await API.getCommunitiesAfterSignIn();
      } else {
        if (userDetails?.userData?.communityStatus === "communityBlocked") {
          res = await API.getNearByCommunitiesWithDefaulBlocked();
        } else {
          res = await API.getNearByCommunities();
        }
      }
      setCommunityResp(res.data);
      setAllCommunities(res.data.physicalTenantList);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // ==========================
    // NORMAL COUNTRY FLOW
    // ==========================
    if (!isGlobalSearch) {
      setSearchCommunitiesList(communitiesList);

      const filteredData = communitiesList?.filter(
        (item) => item?.followStatus !== 1 && item?.followStatus !== 2,
      );

      setMarkersData(filteredData);
      return;
    }

    // ==========================
    // GLOBAL SEARCH FLOW
    // ==========================

    // Keep list blank until user types
    setSearchCommunitiesList([]);
    setSearchValue("");

    // Show ALL markers globally
    const allCommunities = formattedCommunitiesList(communityResp) || [];

    const filteredGlobalMarkers = allCommunities?.filter(
      (item) => item?.followStatus !== 1 && item?.followStatus !== 2,
    );

    setMarkersData(filteredGlobalMarkers);
  }, [communitiesList, isGlobalSearch, communityResp]);

  const getMapCenter = () => {
    if (currentCountry) {
      return {
        lat: !isNaN(+currentCountry?.latitude) ? +currentCountry?.latitude : 0,
        lng: !isNaN(+currentCountry?.longitude)
          ? +currentCountry?.longitude
          : 0,
      };
    }
    return indiaCenter;
  };

  const handleSearch = (e) => {
    const value = e.target.value || "";

    setSearchValue(value);

    // GLOBAL SEARCH
    if (isGlobalSearch) {
      // Empty input -> keep blank
      if (!value.trim()) {
        setSearchCommunitiesList([]);
        return;
      }

      // Get all formatted communities
      const allFormattedCommunities =
        formattedCommunitiesList(communityResp) || [];

      // Search globally
      const searchResult = allFormattedCommunities.filter((item) =>
        item?.communityName?.toLowerCase().includes(value.toLowerCase()),
      );

      setSearchCommunitiesList(searchResult);
      return;
    }

    // NORMAL COUNTRY SEARCH
    if (value.trim()) {
      const searchResult = communitiesList?.filter((item) =>
        item?.communityName?.toLowerCase().includes(value.toLowerCase()),
      );

      setSearchCommunitiesList(searchResult);
    } else {
      handleClear();
    }
  };

  const makeDefaultHandlerForBlockedCommunity = async (id, commName) => {
    const data = new FormData();
    data.append("userDefaultTenantId", id);
    const res = await API.updateDefaultTenant(data);
    if (res?.data?.status === "Community updated successfully") {
      communityContext?.onChangeCommunity({
        tenantId: id,
        tenantName: commName,
      });
      Cookies.set("signInStatus", true);
      history.push("/Home");
    }
  };

  const onLogoClickBeforeSignIn = () => {
    if (
      userDetails?.userData?.communityStatus === "communityBlocked" ||
      String(userDetails?.userData?.currentCommunityStatus) === "0"
    ) {
      dispatch(SigInOutActions.signOut());
      window.location.href = "/";
    } else {
      window.location.href = "/";
      // history.push("/");
    }
  };

  const handleClear = () => {
    setSearchValue("");

    // GLOBAL SEARCH
    if (isGlobalSearch) {
      setSearchCommunitiesList([]);
    } else {
      // COUNTRY SEARCH
      setSearchCommunitiesList(communitiesList);
    }

    setShowTooltip(false);
    setSelectedMarker("");
    setSelectedItem("");

    map?.panTo(getMapCenter());
    map?.setZoom(4);
  };

  const handleMakeDefault = (name, tenantId, countryName) => {
    if (
      userDetails?.userData?.communityStatus === "communityBlocked" ||
      String(userDetails?.userData?.currentCommunityStatus) === "0"
    ) {
      makeDefaultHandlerForBlockedCommunity(tenantId, name);
    } else {
      // set signup context data
      signupContext?.setSignupState({
        community: name,
        tenantId: tenantId,
      });

      //going back to home screen
      history.push("/");
    }
  };

  const handleViewActivity = async (
    communitName,
    tenantId,
    countryName,
    communityType,
    viewActivityPage,
    defaultCountry,
  ) => {
    try {
      const response = await API.viewActivityCommunity(communitName, tenantId);
      // const response = await API.changeCommunity(communitName, tenantId);
      if (response) {
        history.push(viewActivityPage, {
          community: communitName,
          tenantId: tenantId,
          email: location?.state?.email,
          password: location?.state?.password,
          displayName: location?.state?.displayName,
          signIn: signIn,
          communityType: communityType,
          defaultCountry: defaultCountry,
        });
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleListItem = (id, location) => {
    if (selectedItem === id) {
      setSelectedItem("");
      setShowTooltip(false);
      map?.panTo(getMapCenter());
      map?.setZoom(4);
      setSelectedMarker("");
    } else {
      setSelectedItem(id);
      map?.panTo(location);
      map?.setZoom(7);
      setShowTooltip(true);
      setSelectedMarker(id);
    }
  };

  const handleMouseOver = (id, location) => {
    // setSelectedItem(id);
    // map?.panTo(location);
    // map?.setZoom(7);
  };

  const handleMouseOut = () => {
    // setSelectedItem('');
    // map?.panTo(getMapCenter());
    // map?.setZoom(4);
  };

  const handleMakeDefaultAfterSignIn = async (id) => {
    let formdata = new FormData();
    formdata.append("userDefaultTenantId", id);
    await API.setDefaultTenant(formdata)
      .then((res) => {
        setDefaultResponse(res);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleMakeFollowUnfollow = async (id, name, status) => {
    let formdata = new FormData();
    formdata.append("communityID", id);
    formdata.append("communityName", name);
    formdata.append("followStat", status === 0 ? 1 : 0);
    formdata.append("sourceApp", "WebApp");
    await API.followUnfollowCommunity(formdata)
      .then((res) => {
        setFollowStatusResponse(res);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleStartCommunity = () => {
    setOpenStartCommunity(true);
    setShowPrivateAlertPopup(false);
  };

  const handleClose = () => {
    setOpenStartCommunity(false);
    setShowPrivateAlertPopup(false);

    //on close of start community
    // before signin flow - set country to USA as default
    if (signIn) {
      if (
        (prevSelectedCountry && prevSelectedCountry?.country_name) ||
        showPrivateAlertPopupStatus
      ) {
        if (defaultTenantCountry) {
          const defaultCountry = countryList.find(
            (country) => country.country_name === defaultTenantCountry,
          );
          if (defaultCountry && defaultCountry.countryId) {
            setChangedCountry(defaultCountry);
          }
        } else {
          setChangedCountry({ ...prevSelectedCountry });
          setPrevSelectedCountry({});
        }
      }
    } else {
      if (hasCountryCommunity && !showPrivateAlertPopupStatus) {
        setChangedCountry(currentCountry);
      } else {
        setChangedCountry(
          countryList.find((country) => country.countryId === 1) ?? {},
        );
      }

      // If the user is in the "Search or Start Community" section before signing up,
      // and they select the "Start button" button but then close the start community form,
      // it should return to the "Search or Start Community" section.
      setShowSearchBeforeSignIn(isClickedOnSearchTxt);
    }
  };

  const onClickSearchOrStartComm = (key) => {
    if (key === "start") {
      handleStartCommunity();
      // setChangedCountry({});
    }
    setIsClickOnSearchTxt(key === "search");
    setShowSearchBeforeSignIn(true);
  };

  const getLoader = () => {
    if (loading) {
      return (
        <div
          style={{
            marginBottom: "10px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <CircularProgress />
        </div>
      );
    }
    return null;
  };

  const onSkopicClick = async () => {
    try {
      const response = await API.changeCommunity(
        settingsData?.userTenant,
        settingsData?.userTenantId,
      );
      if (response) {
        communityContext?.onChangeCommunity({
          tenantId: settingsData?.userTenantId,
          tenantName: settingsData?.userTenant,
        });
      }
    } catch (e) {
      console.error(e);
    }
  };

  const dialCode = useMemo(() => {
    return (
      countryDialCodeData?.find(
        (it) => it?.name === currentCountry?.country_name,
      )?.dialCode ?? "+1"
    );
  }, [currentCountry]);

  return (
    <>
      {signIn ? (
        <Page hideSearch onSkopicClick={onSkopicClick}>
          <Grid container style={{ padding: "10px 10px 10px 20px" }}>
            <Grid
              item
              xs={12}
              md={3}
              style={{
                display: "flex",
                flexDirection: "column",
                height: "calc(100vh - 120px)",
              }}
            >
              <div className={searchClass}>
                <SearchBox
                  searchValue={searchValue}
                  handleSearch={handleSearch}
                  handleClear={handleClear}
                  defaultCountry={currentCountry}
                  onChangeCountry={onChangeCountry}
                  countryList={countryList}
                  countryTenantList={countryTenantList}
                  updateAlertShow={updateAlertShow}
                  signIn={signIn}
                  setIsPrivatePopupClosed={setIsPrivatePopupClosed}
                  setCountryHasDefaultCommBlocked={
                    setCountryHasDefaultCommBlocked
                  }
                  setIsGlobalSearch={setIsGlobalSearch}
                />
              </div>
              {getLoader()}
              <div
                ref={listRef}
                style={{
                  // height: "calc(100vh - 190px)",
                  // overflowY: "scroll",
                  paddingRight: "10px",
                  flex: 1,
                  overflow: "auto",
                  width: "100%",
                }}
              >
                {showPrivateAlertPopup ? (
                  <PrivateCommunityAlert
                    communityName={currentCountry?.country_name ?? ""}
                    hasCountryCommunity={hasCountryCommunity}
                    onClose={() => {
                      setShowPrivateAlertPopup(false);
                      setIsPrivatePopupClosed(false);
                    }}
                    openStartCommunityPopup={() => {
                      setShowPrivateAlertPopup(false);
                      setOpenStartCommunity(true);
                    }}
                  />
                ) : (
                  <CommunitiesList
                    data={searchCommunitiesList}
                    handleMakeDefault={handleMakeDefault}
                    handleListItem={handleListItem}
                    selectedItem={selectedItem}
                    country={currentCountry?.country_name}
                    handleMouseOver={handleMouseOver}
                    handleMouseOut={handleMouseOut}
                    handleViewActivity={handleViewActivity}
                    handleMakeDefaultAfterSignIn={handleMakeDefaultAfterSignIn}
                    handleMakeFollowUnfollow={handleMakeFollowUnfollow}
                    signIn={signIn}
                    locationIconClickedCommunityId={
                      locationIconClickedCommunityId
                    }
                    hasCountryCommunity={hasCountryCommunity}
                    loading={loading}
                    openStartCommunity={openStartCommunity}
                    searchValue={searchValue}
                    isPrivatePopupClosed={isPrivatePopupClosed}
                    defaultCountry={currentCountry}
                    countryHasDefaultCommBlocked={countryHasDefaultCommBlocked}
                    showAlertBox={showAlertBox}
                    setShowAlertBox={setShowAlertBox}
                    openStartCommunityPopup={() => {
                      setOpenStartCommunity(true);
                    }}
                    isGlobalSearch={isGlobalSearch}
                  />
                )}
              </div>
            </Grid>
            {!loading ? (
              <Grid
                item
                xs={12}
                md={9}
                style={{
                  paddingLeft: "10px",
                  position: "relative",
                  display: "flex",
                  flexDirection: "column",
                  height: "calc(100vh - 120px)",
                }}
              >
                <div style={{ flex: 1 }}>
                  <Map
                    markers={markersData}
                    country={currentCountry}
                    countryCode={currentCountry?.country_code}
                    selectedItem={selectedItem}
                    setMap={setMap}
                    map={map}
                    key={currentCountry?.country_code}
                    showTooltip={showTooltip}
                    selectedMarker={selectedMarker}
                    setSelectedMarker={setSelectedMarker}
                    setShowTooltip={setShowTooltip}
                    setSelectedItem={setSelectedItem}
                    setLocationIconClickedCommunityId={
                      setLocationIconClickedCommunityId
                    }
                    isGlobalSearch={isGlobalSearch}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    position: "absolute",
                    top: "20px",
                    left: "40px",
                  }}
                >
                  <div className={buttonContainer}>
                    <Button
                      variant={"outlined"}
                      style={{ borderRadius: "15px" }}
                      onClick={handleStartCommunity}
                    >
                      <img src={AddIcon} alt="add" />
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "left",
                          alignItems: "baseline",
                          marginLeft: "20px",
                        }}
                      >
                        <p
                          style={{ marginBottom: "2px", fontWeight: "bolder" }}
                        >
                          Start
                        </p>
                        <p
                          style={{ marginBottom: "2px", fontWeight: "bolder" }}
                        >
                          Community
                        </p>
                      </div>
                    </Button>
                  </div>
                </div>
              </Grid>
            ) : (
              <Grid
                item
                xs={12}
                md={9}
                style={{
                  position: "relative",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "gray",
                  fontSize: "23px",
                }}
              >
                <p>We’re setting the map to show your selected country...</p>
              </Grid>
            )}
            {openStartCommunity && (
              <StartCommunities
                open={openStartCommunity}
                close={handleClose}
                allCommunities={allCommunities}
                signIn={signIn}
                defaultCountryName={
                  isGlobalSearch ? "" : currentCountry?.country_name
                }
                defaultCountryDialCode={dialCode}
                hasCountryCommunity={hasCountryCommunity}
                isGlobalSearch={isGlobalSearch}
              />
            )}
          </Grid>
        </Page>
      ) : (
        <div style={{ backgroundColor: "#F3F2F0" }}>
          <Grid
            container
            style={{ padding: "0px 30px", height: "80px", background: "#fff" }}
          >
            <Grid
              item
              xs={3.5}
              style={{ display: "flex", alignItems: "center" }}
            >
              <div onClick={onLogoClickBeforeSignIn}>
                <img
                  style={{
                    cursor: "pointer",
                    objectFit: "cover",
                    width: "90px",
                    height: "48px",
                  }}
                  src={logo}
                  alt="Skopic Logo"
                />
              </div>
            </Grid>
            <Grid
              item
              xs={8.5}
              style={{
                display: "flex",
                alignItems: "flex-end",
                paddingLeft: "30px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "flex-start",
                  width: "100%",
                }}
              >
                <p
                  style={{
                    fontSize: "17px",
                    color:
                      userDetails?.userData?.communityStatus ===
                        "communityBlocked" ||
                      String(userDetails?.userData?.currentCommunityStatus) === "0"
                        ? "red"
                        : "#373334",
                  }}
                >
                  <span>
                    {hasCountryCommunity
                      ? userDetails?.userData?.communityStatus ===
                        "communityBlocked"
                        ? "Access to your default community has been blocked by the moderator. Choose a new default community to continue Sign In."
                        : String(userDetails?.userData?.currentCommunityStatus) === "0"
                          ? "Your Default Community is Inactive. Choose a new default community to continue Sign In."
                          : "Choose or Start your Default Community"
                      : ""}
                  </span>
                </p>
                {userDetails?.userData?.communityStatus ===
                  "communityBlocked" ||
                String(userDetails?.userData?.currentCommunityStatus) === "0" ? (
                  <div>
                    {" "}
                    <button
                      className={DefaultBlockedCloseBtn}
                      onClick={onLogoClickBeforeSignIn}
                    >
                      <img src={CloseButton} alt="close" />
                    </button>
                  </div>
                ) : (
                  <div>
                    <IconButton
                      onClick={onClickDisplayNameInfo}
                      className={styles.informationIcon}
                      style={{ marginTop: "-10px" }}
                    >
                      <InfoOutlinedIcon style={{ fontSize: "20px" }} />
                    </IconButton>
                    <Popover
                      id={informationId}
                      open={open}
                      anchorEl={anchorEl}
                      onClose={onHideDisplayNameInfo}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "center",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "center",
                      }}
                    >
                      <Typography
                        style={{ padding: "10px", maxWidth: "300px" }}
                      >
                        Choose a Community where you involve the most. If you
                        don’t see a Community of your choice, you can request to
                        start a new Community which will be assigned as your
                        default Community upon approval.
                      </Typography>
                    </Popover>
                  </div>
                )}
              </div>
            </Grid>
          </Grid>
          <Grid container style={{ padding: "10px 10px 10px 20px" }}>
            <Grid
              item
              xs={3}
              style={{
                display: "flex",
                flexDirection: "column",
                height: "calc(100vh - 110px)",
              }}
            >
              <div className={searchClass}>
                {!showSearchBeforeSignIn && previousCountry === undefined ? (
                  <div className={searchOrStartBtn}>
                    <button
                      className={searchBtn}
                      onClick={() => onClickSearchOrStartComm("search")}
                    >
                      Search
                    </button>
                    &nbsp;or&nbsp;
                    <button
                      className={searchBtn}
                      onClick={() => onClickSearchOrStartComm("start")}
                    >
                      Start
                    </button>
                    &nbsp;Community
                  </div>
                ) : (
                  <SearchBox
                    searchValue={searchValue}
                    handleSearch={handleSearch}
                    handleClear={handleClear}
                    defaultCountry={currentCountry}
                    onChangeCountry={onChangeCountry}
                    countryList={countryList}
                    countryTenantList={countryTenantList}
                    updateAlertShow={updateAlertShow}
                    setIsPrivatePopupClosed={setIsPrivatePopupClosed}
                    setCountryHasDefaultCommBlocked={
                      setCountryHasDefaultCommBlocked
                    }
                    setIsGlobalSearch={setIsGlobalSearch}
                  />
                )}
              </div>
              {getLoader()}
              <div
                ref={listRef}
                style={{
                  // height: "calc(100vh - 190px)",
                  // overflowY: "scroll",
                  paddingRight: "10px",
                  flex: 1,
                  overflow: "auto",
                }}
              >
                {showPrivateAlertPopup ? (
                  <PrivateCommunityAlert
                    communityName={currentCountry?.country_name ?? ""}
                    hasCountryCommunity={hasCountryCommunity}
                    onClose={() => {
                      setShowPrivateAlertPopup(false);
                      setIsPrivatePopupClosed(false);
                    }}
                    openStartCommunityPopup={() => {
                      setShowPrivateAlertPopup(false);
                      setOpenStartCommunity(true);
                    }}
                  />
                ) : (
                  <CommunitiesList
                    data={searchCommunitiesList}
                    handleMakeDefault={handleMakeDefault}
                    handleListItem={handleListItem}
                    selectedItem={selectedItem}
                    country={currentCountry?.country_name}
                    handleMouseOver={handleMouseOver}
                    handleMouseOut={handleMouseOut}
                    handleViewActivity={handleViewActivity}
                    handleMakeDefaultAfterSignIn={handleMakeDefaultAfterSignIn}
                    handleMakeFollowUnfollow={handleMakeFollowUnfollow}
                    signIn={signIn}
                    locationIconClickedCommunityId={
                      locationIconClickedCommunityId
                    }
                    hasCountryCommunity={hasCountryCommunity}
                    loading={loading}
                    openStartCommunity={openStartCommunity}
                    searchValue={searchValue}
                    isPrivatePopupClosed={isPrivatePopupClosed}
                    defaultCountry={currentCountry}
                    countryHasDefaultCommBlocked={countryHasDefaultCommBlocked}
                    showAlertBox={showAlertBox}
                    setShowAlertBox={setShowAlertBox}
                    openStartCommunityPopup={() => {
                      setOpenStartCommunity(true);
                    }}
                    isGlobalSearch={isGlobalSearch}
                  />
                )}
              </div>
            </Grid>
            {!loading ? (
              <Grid
                item
                xs={9}
                style={{
                  paddingLeft: "10px",
                  position: "relative",
                  display: "flex",
                  flexDirection: "column",
                  height: "calc(100vh - 110px)",
                }}
              >
                <div style={{ flex: 1 }}>
                  <Map
                    markers={markersData}
                    country={currentCountry}
                    countryCode={currentCountry?.country_code}
                    selectedItem={selectedItem}
                    setMap={setMap}
                    map={map}
                    key={currentCountry?.country_code}
                    showTooltip={showTooltip}
                    selectedMarker={selectedMarker}
                    setSelectedMarker={setSelectedMarker}
                    setShowTooltip={setShowTooltip}
                    setSelectedItem={setSelectedItem}
                    setLocationIconClickedCommunityId={
                      setLocationIconClickedCommunityId
                    }
                    isGlobalSearch={isGlobalSearch}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    position: "absolute",
                    top: "20px",
                    left: "40px",
                  }}
                >
                  <div
                    className={buttonContainer}
                    style={{
                      display:
                        showSearchBeforeSignIn || previousCountry !== undefined
                          ? "block"
                          : "none",
                    }}
                  >
                    <Button
                      variant={"outlined"}
                      style={{
                        borderRadius: "15px",
                        padding: "10px 17px",
                        textTransform: "none",
                      }}
                      onClick={handleStartCommunity}
                    >
                      <img src={AddIcon} alt="add" />
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "left",
                          alignItems: "baseline",
                          marginLeft: "20px",
                        }}
                      >
                        <p
                          style={{ marginBottom: "-3px", fontWeight: "bolder" }}
                        >
                          Start
                        </p>
                        <p
                          style={{ marginBottom: "2px", fontWeight: "bolder" }}
                        >
                          Community
                        </p>
                      </div>
                    </Button>
                  </div>
                </div>
              </Grid>
            ) : (
              <Grid
                item
                xs={12}
                md={9}
                style={{
                  position: "relative",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {getLoader()}
              </Grid>
            )}
            {openStartCommunity && (
              <StartCommunities
                open={openStartCommunity}
                close={handleClose}
                allCommunities={allCommunities}
                defaultCountryName={
                  isGlobalSearch ? "" : currentCountry?.country_name
                }
                defaultCountryDialCode={dialCode}
                hasCountryCommunity={hasCountryCommunity}
                isGlobalSearch={isGlobalSearch}
              />
            )}
          </Grid>
        </div>
      )}
    </>
  );
};

export default DefaultCommunity;

function PrivateCommunityAlert({
  communityName,
  hasCountryCommunity,
  openStartCommunityPopup,
  onClose,
}) {
  return (
    <div
      style={{
        border: "1px solid #373334",
        fontSize: "16px",
        padding: "12px",
        borderRadius: "20px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        backgroundColor: "white",
        color: "#707070",
      }}
    >
      <IconButton
        onClick={onClose}
        style={{
          marginLeft: "auto",
          padding: "2px",
          marginTop: "-8px",
          marginRight: "-6px",
          outline: "none !important",
        }}
      >
        <IoIosClose />
      </IconButton>
      {!hasCountryCommunity
        ? `There are no communities available to follow in ${communityName}. Click OK to start a new community`
        : `There are only private communities in ${communityName} and no public communities to follow. Click Ok to start a new community.`}

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginTop: "18px",
        }}
      >
        <button
          style={{
            backgroundColor: "#3B82F6",
            color: "white",
            fontSize: "14px",
            border: "none",
            width: "80px",
            padding: "4px",
            borderRadius: "6px",
          }}
          onClick={openStartCommunityPopup}
        >
          Ok
        </button>
      </div>
    </div>
  );
}
